var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"squizzy-squid"},[_c('img',{staticStyle:{"max-width":"200px","max-height":"139px","width":"auto","height":"auto"},attrs:{"src":_vm.image}})])
}
var staticRenderFns = []

export { render, staticRenderFns }